/* istanbul ignore next */
(function(angular) {
    'use strict';
    angular.module('bm.practice.receiptAndAdjustment', [
        'receipt.and.adjustment.templates',
        'bm.practice.receiptAndAdjustment.ReceiptAndAdjustmentPageController',
        'bm.practice.receiptAndAdjustment.ReceiptAndAdjustmentEntryForm',
        'bm.practice.receiptAndAdjustment.ReceiptsRecap',
        'bm.practice.receiptAndAdjustment.ReceiptAndAdjustmentDailyEntryController',
        'bm.practice.receiptAndAdjustment.ReceiptAndAdjustmentRecapProvider',
        'bm.practice.receiptAndAdjustment.ReviewController'
    ]);
}(window.angular));
